import { selectActiveDepreciateSeparatelyID } from '../../../../redux/features/selectors/uiSelectors.ts';
import { setActiveDepreciateSeparatelyID } from '../../../../redux/features/uiSlice.ts';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.ts';
import { FormWithReferenceViewModal } from '../../modals/FormWithReferenceViewModal/FormWithReferenceViewModal.tsx';
import { DepreciateSeparatelyModalContent } from './DepreciateSeparatelyModalContent.tsx';

export const DepreciateSeparatelyModal = ({
  isModalOpen,
  onModalClose,
  compSequence,
}: {
  onModalClose: () => void;
  isModalOpen: boolean;
  compSequence: string[];
}) => {
  const dispatch = useAppDispatch();
  const activeId = useAppSelector(selectActiveDepreciateSeparatelyID);

  return (
    <FormWithReferenceViewModal
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      compSequence={compSequence}
      activeId={activeId}
      setActiveId={(id) => dispatch(setActiveDepreciateSeparatelyID(id))}
      formValid={true}
      invalidFormWarning={'INVALID_FORM_WARNING'}
    >
      <DepreciateSeparatelyModalContent />
    </FormWithReferenceViewModal>
  );
};
